export const urls = {
	startOptimize: '/rest/jpo/1.0/scheduling',
	pollOptimize: '/rest/jpo/1.0/scheduling/poll',
	applyChange: '/rest/jpo/1.0/scheduling/commit',
	pollApplying: (id: string) => `/rest/jpo/1.0/scheduling/commit/${id}`,
} as const;
